import { AutogenModelCollectionsProfile, AutogenRowCollectionsProfile } from "./autogen/AutogenModelCollectionsProfile";

export class ModelCollectionsProfile extends AutogenModelCollectionsProfile<RowCollectionsProfile> {
	constructor() {
		super(RowCollectionsProfile);
	}
}

export class RowCollectionsProfile extends AutogenRowCollectionsProfile {
}